import { FC, ReactNode } from "react";
import styles from "./Header.module.scss";
import { Severity } from "../../Helpers";
import { classNames } from "../../Utilities";

interface HeaderProps {
    title: ReactNode;
    level?: number;
    right?: ReactNode;
    className?: string;
    severity?: Severity;
    size?: HeaderSize;
}

export enum HeaderSize {
    Small, // Small print size
    Normal, // Normal text
    Large, // Normal h3
    XLarge, // Normal h2
    XXLarge // Normal h1
}

export const Header: FC<HeaderProps> = (props) => {
    const getSeverityClass = (): string | null => {
        switch (props.severity) {
            case Severity.Primary:
                return styles.primary;
            case Severity.Secondary:
                return styles.secondary;
            case Severity.Tertiary:
                return styles.tertiary;
            case Severity.Info:
                return styles.info;
            case Severity.Success:
                return styles.success;
            case Severity.Warning:
                return styles.warning;
            case Severity.Danger:
                return styles.danger;
            default:
                return null;
        }
    };

    const getSizeClass = (): string | null => {
        switch (props.size) {
            case HeaderSize.Small:
                return styles.small;
            case HeaderSize.Normal:
                return styles.normal;
            case HeaderSize.Large:
                return styles.large;
            case HeaderSize.XLarge:
                return styles.xlarge;
            case HeaderSize.XXLarge:
                return styles.xxlarge;
            default:
                return null;
        }
    };

    const getHeading = (): ReactNode => {
        switch (props.level) {
            case 2:
                return <h2 className={classNames([getSeverityClass(), getSizeClass(), props.className])}>{props.title}</h2>;
            case 3:
                return <h3 className={classNames([getSeverityClass(), getSizeClass(), props.className])}>{props.title}</h3>;
            case 4:
                return <h4 className={classNames([getSeverityClass(), getSizeClass(), props.className])}>{props.title}</h4>;
            case 5:
                return <h5 className={classNames([getSeverityClass(), getSizeClass(), props.className])}>{props.title}</h5>;
            case 6:
                return <h6 className={classNames([getSeverityClass(), getSizeClass(), props.className])}>{props.title}</h6>;
            default:
                return <h1 className={classNames([getSeverityClass(), getSizeClass(), props.className])}>{props.title}</h1>;
        }
    };

    return (
        <div className={styles.split}>
            <div>
                {getHeading()}
            </div>
            {!!props.right && (
                <div className={styles.right}>
                    {props.right}
                </div>
            )}
        </div>
    );
};